export const GO_TO_MANAGER = 'GO_TO:MANAGER';
export const GO_TO_CREATE = 'GO_TO:CREATE';
export const GO_TO_EDIT = 'GO_TO:EDIT';
export const GO_TO_ANALYTICS = 'GO_TO:ANALYTICS';
export const GO_TO_ENRICH = 'GO_TO:ENRICH';
export const GO_TO_NEW_AREA = 'GO_TO_NEW_AREA';
export const LOGOUT = 'LOGOUT';
